import {
  PLAYLIST_LOADING,
  PLAYLIST_SET_DATA,
  PLAYLIST_SET_DETAILS,
  PLAYLIST_SET_OWN_DATA,
  PLAYLIST_SET_FOLLOWING_DATA,
  CREATE_SESSION_START,
  CREATE_SESSION_SUCCESS,
  CREATE_SESSION_FAILURE,
  GET_SESSION_START,
  GET_SESSION_SUCCESS,
  GET_SESSION_FAILURE,
  GET_SESSION_BY_USER_START,
  GET_SESSION_BY_USER_SUCCESS,
  GET_SESSION_BY_USER_FAILURE,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  ENROLE_COURSE_START,
  ENROLE_COURSE_SUCCESS,
  ENROLE_COURSE_FAILURE,
  GET_ENROLE_COURSE_START,
  GET_ENROLE_COURSE_SUCCESS,
  GET_ENROLE_COURSE_FAILURE,
} from "./constants";
const initialState = {
  loading: null,
  errorMessage: {},
  playlist: [],
  playlistDetail: {},
  ownPlaylist: [],
  followingPlaylist: [],
  newSession: [],
  sessionList: [],
  allSessionList: [],
  searchedData: [],
  loadedSearchData: false,
  enroleCourse: [],
  myEnroleCourse: []
};

export function playlistReducer(state = initialState, action) {
  switch (action.type) {
    case PLAYLIST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PLAYLIST_SET_DATA:
      return {
        ...state,
        playlist: action.payload,
        loading: false,
      };
    case PLAYLIST_SET_DETAILS:
      return {
        ...state, 
        playlistDetail: action.payload
      }
    case PLAYLIST_SET_OWN_DATA:
      return {
        ...state,
        ownPlaylist: action.payload,
      };
    case PLAYLIST_SET_FOLLOWING_DATA:
      return {
        ...state,
        followingPlaylist: action.payload,
      };
    case CREATE_SESSION_START:
      return {
        ...state,
        loading: true,
      };
    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        newSession: action.payload,
      };
    case CREATE_SESSION_FAILURE:
      return {
        ...state, 
        loading: false,
        errorMessage: action.payload
      }
      case GET_SESSION_START:
        return {
          ...state,
          loading: true,
        };
      case GET_SESSION_SUCCESS:
        return {
          ...state,
          loading: false,
          sessionList: action.payload,
        };
      case GET_SESSION_FAILURE:
        return {
          ...state, 
          loading: false,
          errorMessage: action.payload
        }
      case GET_SESSION_BY_USER_START:
        return {
          ...state,
          loading: true,
        };
      case GET_SESSION_BY_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          allSessionList: action.payload,
        };
      case GET_SESSION_BY_USER_FAILURE:
        return {
          ...state, 
          loading: false,
          errorMessage: action.payload
        }
      case SEARCH_START:
        return {
          ...state,
          loading: true,
          loadedSearchData: false
        };
      case SEARCH_SUCCESS:
        return {
          ...state,
          loading: false,
          loadedSearchData: true,
          searchedData: action.payload,
        };
      case SEARCH_FAILURE:
        return {
          ...state,
          loading: false, 
          loadedSearchData: false,
          errorMessage: action.payload
        }
      case ENROLE_COURSE_START:
        return {
          ...state,
          loading: true
        };
      case ENROLE_COURSE_SUCCESS:
        return {
          ...state,
          loading: false,
          enroleCourse: [ ...state.enroleCourse , action.payload],
        };
      case ENROLE_COURSE_FAILURE:
        return {
          ...state,
          loading: false,
          errorMessage: action.payload
        }
      case GET_ENROLE_COURSE_START:
        return {
          ...state,
          loading: true
        };
      case GET_ENROLE_COURSE_SUCCESS:
        return {
          ...state,
          loading: false,
          myEnroleCourse: action.payload,
        };
      case GET_ENROLE_COURSE_FAILURE:
        return {
          ...state,
          loading: false,
          errorMessage: action.payload
        }
    default:
      return state;
  }
}
